import { useReduxState } from 'hooks';
import { ContentLabel, ContentValue } from 'components/common';
import { AttributeDisplayValue } from '.';

import type { Achievement, CustomAttributes } from 'shared-types';
import { availableCustomAttributesByType } from 'lib/customAttributes';

interface Props {
  customAttributes: CustomAttributes;
  inProfile?: boolean;
  labelSpacing?: number;
  position?: 'default' | 'at start';
  productType: 'calendarEvent' | 'course' | 'path' | Achievement['type'];
}

const DisplayAttributeInProductPage = ({
  customAttributes,
  inProfile = false,
  labelSpacing = 20,
  position = 'default',
  productType
}: Props) => {
  const { language, serverConfig } = useReduxState();

  const availableAttributes = availableCustomAttributesByType({
    serverConfig,
    type: productType
  });

  const validAttributes =
    availableAttributes?.filter((attr) =>
      attr.displayInProductPage && position === 'default'
        ? !attr.displayInProductPageAtStart
        : attr.displayInProductPageAtStart
    ) || [];

  return !customAttributes ? null : (
    <>
      {validAttributes.length
        ? validAttributes.map((attr) =>
            customAttributes?.[attr.key] ? (
              <ContentLabel
                key={attr.key}
                horizontal={!inProfile}
                label={attr.titleData?.[language] || attr.title}
                spacing={labelSpacing}
              >
                <ContentValue style={{ fontWeight: 600 }}>
                  <AttributeDisplayValue value={customAttributes[attr.key]} />
                </ContentValue>
              </ContentLabel>
            ) : null
          )
        : null}
    </>
  );
};

export default DisplayAttributeInProductPage;
